/**
 * Santander BFF component for add-family-member MFE
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface InsuredPersonDTO {
  title?: InsuredPersonDTOTitleEnum;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  circumstanceType?: InsuredPersonDTOCircumstanceTypeEnum;
  circumstanceDescription?: string;
}
export enum InsuredPersonDTOTitleEnum {
  Mr = 'Mr.',
  Mrs = 'Mrs.',
  Ms = 'Ms.',
  Miss = 'Miss.',
  M = 'M.',
  Baron = 'Baron',
  Baroness = 'Baroness',
  Dame = 'Dame',
  Doctor = 'Doctor',
  Father = 'Father',
  Judge = 'Judge',
  Lady = 'Lady',
  Lord = 'Lord',
  Major = 'Major',
  Professor = 'Professor',
  Reverend = 'Reverend',
  RightHonourable = 'Right Honourable',
  Sir = 'Sir',
}
export enum InsuredPersonDTOCircumstanceTypeEnum {
  Capability = 'Capability',
  Health = 'Health',
  LifeEvents = 'Life events',
  Resilience = 'Resilience',
}
